import React, {
  useState,
  ReactElement,
} from 'react';
import { Popover, ArrowContainer } from 'react-tiny-popover';

import * as S from './styled';

type Position = 'top' | 'right' | 'bottom' | 'left';

interface Props {
  fill?: 'light' | 'dark';
  body?: string | ReactElement<any>;
  width?: string;
  isOpen?: boolean;
  children: ReactElement<any>;
  positions?: Position[];
  toggleMode?: boolean;
  initialState?: boolean;
}

const Tooltip = ({
  body = '',
  fill = 'dark',
  width = '150px',
  positions = ['bottom'],
  toggleMode = false,
  initialState = false,
  isOpen,
  children,
}: Props) => {
  const [isOpenState, setIsOpen] = useState(initialState);

  const triggerProps = toggleMode ? {
    onClick: (event: Event) => {
      setIsOpen(!isOpenState);
      children?.props.onClick?.(event);
    },
  } : {
    onMouseOver: () => setIsOpen(true),
    onMouseOut: () => setIsOpen(false),
  };

  return (
    <Popover
      isOpen={typeof isOpen !== 'undefined' ? isOpen : isOpenState}
      positions={positions}
      content={({ position, childRect, popoverRect }) => (
        <ArrowContainer
          position={position}
          childRect={childRect}
          popoverRect={popoverRect}
          arrowColor={fill === 'light' ? 'rgba(255, 255, 255, 0.9)' : 'rgba(17, 17, 17, 0.9)'}
          arrowSize={10}
          className="popover-arrow-container-fade-in"
          arrowClassName="popover-arrow"
        >
          <S.Body
            fill={fill!}
            width={width}
          >
            <p
              style={{ margin: '0' }}
            >
              {body}
            </p>
          </S.Body>
        </ArrowContainer>
      )}
    >
      {React.cloneElement(
        children,
        triggerProps,
      )}
    </Popover>
  );
};

export default Tooltip;
